import { render, staticRenderFns } from "./writeEmail.vue?vue&type=template&id=315b6ed1&scoped=true&"
import script from "./writeEmail.vue?vue&type=script&lang=js&"
export * from "./writeEmail.vue?vue&type=script&lang=js&"
import style0 from "./writeEmail.vue?vue&type=style&index=0&id=315b6ed1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315b6ed1",
  null
  
)

export default component.exports